import React from 'react';
import { bool, string } from 'prop-types';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import { NamedLink } from '../../components';
import image from '../../assets/object.png';
import NYTBadge from '../../assets/NYT Badge.png';
import css from './SectionHero.module.css';

const SectionHero = props => {
  const { rootClassName, className, products, showNYTBadge } = props;
  const intl = useIntl();

  const classes = classNames(rootClassName || css.root, className);

  const heroTitle = intl.formatMessage({ id: 'SectionHero.title' });
  const heroSubTitle = intl.formatMessage({ id: 'SectionHero.subTitle' });

  const emphasisWords = ['test', 'loyalty'];
  const emphasisPattern = new RegExp(`(${emphasisWords.join('|')})`, 'gi');
  const titleParts = heroTitle.split(emphasisPattern);

  return (
    <div className={classes} role="banner">
      {showNYTBadge ? (
        <div className={css.badgeMobileWrapper}>
          <a
            href="https://www.nytimes.com/2023/08/28/style/loyalty-test-infidelity-cheating.html"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Read about us in the New York Times"
            className={css.nytBadgeLink}
          >
            <img src={NYTBadge} alt="New York Times Badge" className={css.nytBadgeImage} />
          </a>
        </div>
      ) : null}
      <div className={css.container}>
        <div className={css.left}>
          <div className={classNames(css.leftContent, { [css.leftContentWithBadge]: showNYTBadge })}>
            {showNYTBadge ? (
              <div className={css.badgeColumn}>
                <a
                  href="https://www.nytimes.com/2023/08/28/style/loyalty-test-infidelity-cheating.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Read about us in the New York Times"
                  className={css.nytBadgeLink}
                >
                  <img src={NYTBadge} alt="New York Times Badge" className={css.nytBadgeImage} />
                </a>
              </div>
            ) : null}
            <div className={css.textColumn}>
            <h1 className={css.heroMainTitle}>
              {titleParts.map((part, i) =>
                emphasisWords.includes(part.toLowerCase()) ? (
                  <span key={i} className={css.heroTitleEmphasis}>{part}</span>
                ) : (
                  <React.Fragment key={i}>{part}</React.Fragment>
                )
              )}
            </h1>
            <p className={css.heroSubTitle}>
              {heroSubTitle}
            </p>
            
            <div className={css.buttonRow}>
              <NamedLink
                name="ChooseTesterPage"
                className={css.heroButton}
                aria-label="Learn how it works"
              >
                <FormattedMessage id="SectionHero.HowItWorksButton" />
              </NamedLink>

              <NamedLink
                name="AboutPage"
                className={css.heroButton}
                aria-label="About our service"
              >
                <FormattedMessage id="SectionHero.browseButton" />
              </NamedLink>
            </div>
            </div>
          </div>
        </div>
        <div className={css.right}>
          <img 
            className={css.image} 
            src={image} 
            alt="Loyalty test illustration" 
            loading="eager" 
            fetchpriority="high"
            width="700" 
            height="700" 
          />
        </div>
      </div>
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null, showNYTBadge: false };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
  showNYTBadge: bool,
};

export default SectionHero;
